<div class="splash-screen" [hidden]="!visible">
  <div class="splash-container">
    <div class="load-bar">
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
    </div>
    <p class="splash-text ">
      <ng-container *ngTemplateOutlet="messageTemplate"></ng-container>
    </p>
  </div>
</div>
